// extracted by mini-css-extract-plugin
module.exports = {"PageWrapper":"DashboardLayout_PageWrapper__Xc3ml"};